

const totalKPIIcon = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="7.5"
          fill="#265AF1"
          fill-opacity="0.1"
          stroke="#CBDBEC"
        />
        <path
          d="M25 20C25 22.7614 22.7614 25 20 25C17.2386 25 15 22.7614 15 20C15 17.2386 17.2386 15 20 15"
          stroke="#010ED0"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M22 10.2C21.3538 10.0689 20.6849 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30C25.5228 30 30 25.5228 30 20C30 19.3151 29.9311 18.6462 29.8 18"
          stroke="#010ED0"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M19.4697 19.4697C19.1768 19.7626 19.1768 20.2374 19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303L20 20L19.4697 19.4697ZM27.6909 12.3091L26.9652 12.4985C27.0337 12.7611 27.2389 12.9663 27.5015 13.0348L27.6909 12.3091ZM27.1745 10.3301L26.4488 10.5194V10.5194L27.1745 10.3301ZM26.298 10.1901L26.8284 10.7204V10.7204L26.298 10.1901ZM25.1487 11.3394L24.6183 10.8091V10.8091L25.1487 11.3394ZM24.2781 14.1513L23.5524 14.3406L23.5524 14.3406L24.2781 14.1513ZM29.6699 12.8255L29.4806 13.5512V13.5512L29.6699 12.8255ZM29.8099 13.702L29.2796 13.1716L29.2796 13.1716L29.8099 13.702ZM28.6606 14.8513L29.1909 15.3817H29.1909L28.6606 14.8513ZM25.8487 15.7219L25.6594 16.4476L25.8487 15.7219ZM24.6031 15.3969L24.0728 14.8665L19.4697 19.4697L20 20L20.5303 20.5303L25.1335 15.9272L24.6031 15.3969ZM27.6909 12.3091L28.4166 12.1198L27.9002 10.1407L27.1745 10.3301L26.4488 10.5194L26.9652 12.4985L27.6909 12.3091ZM26.298 10.1901L25.7677 9.65973L24.6183 10.8091L25.1487 11.3394L25.679 11.8698L26.8284 10.7204L26.298 10.1901ZM24.2781 14.1513L23.5524 14.3406L23.8774 15.5862L24.6031 15.3969L25.3288 15.2075L25.0038 13.9619L24.2781 14.1513ZM27.6909 12.3091L27.5015 13.0348L29.4806 13.5512L29.6699 12.8255L29.8593 12.0998L27.8802 11.5834L27.6909 12.3091ZM29.8099 13.702L29.2796 13.1716L28.1302 14.321L28.6606 14.8513L29.1909 15.3817L30.3403 14.2323L29.8099 13.702ZM25.8487 15.7219L26.0381 14.9962L24.7925 14.6712L24.6031 15.3969L24.4138 16.1226L25.6594 16.4476L25.8487 15.7219ZM28.6606 14.8513L28.1302 14.321C27.5092 14.942 26.6861 15.1652 26.0381 14.9962L25.8487 15.7219L25.6594 16.4476C26.8985 16.7709 28.2525 16.3201 29.1909 15.3817L28.6606 14.8513ZM29.6699 12.8255L29.4806 13.5512C29.4294 13.5378 29.371 13.5052 29.3242 13.4513C29.2797 13.3999 29.2597 13.3456 29.253 13.3035C29.2397 13.2203 29.2733 13.1779 29.2796 13.1716L29.8099 13.702L30.3403 14.2323C30.6526 13.92 30.8014 13.4876 30.7342 13.0669C30.6647 12.6319 30.3587 12.2301 29.8593 12.0998L29.6699 12.8255ZM25.1487 11.3394L24.6183 10.8091C23.6799 11.7475 23.2291 13.1015 23.5524 14.3406L24.2781 14.1513L25.0038 13.9619C24.8348 13.3139 25.058 12.4908 25.679 11.8698L25.1487 11.3394ZM27.1745 10.3301L27.9002 10.1407C27.7699 9.64133 27.3681 9.33528 26.9331 9.26579C26.5124 9.19858 26.08 9.3474 25.7677 9.65973L26.298 10.1901L26.8284 10.7204C26.8221 10.7267 26.7797 10.7603 26.6965 10.747C26.6544 10.7403 26.6001 10.7203 26.5487 10.6758C26.4948 10.629 26.4622 10.5706 26.4488 10.5194L27.1745 10.3301Z"
          fill="#010ED0"
        />
      </svg>
    </div>
  );
};

export default totalKPIIcon;
